import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function IdentityResolutionIcon(props: IconProps) {
  return (
    <Icon width="24px" height="24px" viewBox="0 0 24 24" fill="none" {...props}>
      <rect width="15" height="15" x="1.5" y="1.5" stroke="currentColor" rx="1.667" />
      <rect width="15" height="15" x="7.5" y="7.5" stroke="currentColor" rx="1.667" />
      <Box
        as="path"
        stroke="currentColor"
        d="m7.498 11.601 4.95 4.949M7.923 7.862l8.307 8.308m-4.584-8.766 4.95 4.95"
      />
    </Icon>
  );
}
